<template>
  <v-container fluid>
    <v-row class="mt-6" justify="space-between">
      <v-col cols="6" sm="auto" order="2" order-sm="1">
        <v-btn
          v-if="currentStep > 1"
          color="secondary"
          depressed
          v-on:click="updateParentStep(currentStep - 1)"
        >Zurück</v-btn>
      </v-col>
      <v-col cols="12" sm="auto" order="1" order-sm="2" class="text-center">
        <v-btn
          v-on:click="resetAll()"
          :block="$vuetify.breakpoint.xsOnly"
          color="secondary" outlined depressed
        >Konfiguration zurücksetzen</v-btn>
      </v-col>
      <v-col cols="6" sm="auto" order="3" order-sm="3" class="text-right">
        <v-btn
          v-if="currentStep < lastStep"
          color="primary"
          v-on:click="updateParentStep(currentStep + 1)"
        >Weiter</v-btn>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapState} from "vuex";

export default {
  name: "StepFooterNavigation",
  props: [
    'currentStep',
    'lastStep'
  ],
  computed: {
    ...mapState({
      desktopOptimizedSwitch: state => state.desktopOptimizedSwitch
    }),
    isMobile: function () {
      return this.$vuetify.breakpoint.mobile;
    }
  },
  methods: {
    updateParentStep: function(toStep) {
      if (this.desktopOptimizedSwitch) {
        switch (parseInt(toStep)) {
          case 1:
            toStep =  1
            break;
          case 2:
            toStep =  2
            break;
          case 3:
            toStep = 5
            break;
        }
      }
      this.$emit('update:nextStep',toStep);
    },
    resetAll: function() {
      this.$store.dispatch('resetStore').then(() => {
        this.$store.dispatch('updateDesktopOptimizedSwitch', this.isMobile);
        // reset initial query params to null object
        this.$store.commit('SET_INITIAL_QUERY_PARAMS', {});
        // reload initial data
        this.$store.dispatch('setInitialData');
      });

    }
  }
}
</script>

<style scoped>

</style>
